module.exports = __webpack_public_path__ + "static/img/toolbar-off.c939aa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/app-demo/images/toolbar-off.png
// module id = 5sDo
// module chunks = 12